import { ReactNode } from 'react';

import { ChartRendererProps } from '../../types/chart-renderer-props';
import { ChartListItem, toChartListItems } from '../../utils/to-chart-list-items';
import { useUnknownChartSeriesLabel } from '../shared/use-chart-series-display-name';

export interface ListChartProps extends ChartRendererProps {
    renderItem?: (item: ChartListItem) => ReactNode;
}

const DefaultListItem = ({ item }: { item: ChartListItem }) => (
    <div className='flex w-full items-center justify-between'>
        <div className='flex min-w-0 flex-1 flex-col items-start justify-center gap-0.5'>
            <div className='text-foreground-default justify-start text-base font-semibold'>{item.value}</div>
            <div className='text-brand-muted justify-start text-base font-medium'>{item.name}</div>
        </div>
    </div>
);

export const ListChart = ({ data, className, renderItem }: ListChartProps) => {
    const unknownLabel = useUnknownChartSeriesLabel();
    const items = toChartListItems(data, unknownLabel);

    return (
        <div className={`flex w-full flex-col items-stretch justify-start gap-3 self-stretch ${className ?? ''}`}>
            {items.map((item) => (
                <div
                    key={item.key}
                    className='w-full'>
                    {renderItem ? renderItem(item) : <DefaultListItem item={item} />}
                </div>
            ))}
        </div>
    );
};
